import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { SharedService } from '../../../shared/services/shared.service';
import { InvestmentModel } from '../investment.model';
import { InvestmentFormComponent } from './investment-form.component';
import { InvestmentService } from '../investment.service';


@Component({
    selector: 'convfact-dialog-import-account-investment',
    templateUrl: './investment-dialog-importAccount.component.html',
    styleUrls: ['./investment.component.css'],
    standalone: false
})
export class InvestmentDialogImportAccount {

    dataImport: InvestmentModel = this.data.dataImport;

    constructor(
        public dialogRef: MatDialogRef<InvestmentFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public investmentService: InvestmentService,
        public sharedService: SharedService
    ) { }

    startImport() {
        this.sharedService.importAccountsUpdate(this.dataImport, "IntangibleMaterial").then(result => {
            this.dialogRef.close(); 
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }




}
